import React, { useRef } from "react";
import "./What_Customer_Say.css";
import Homepage_common_heading from "../../Common-Component/Homepage_common_heading/Homepage_common_heading";
import { FaArrowLeft, FaArrowRight } from "react-icons/fa";
import { Swiper, SwiperSlide } from "swiper/react";

const What_Customer_Say = () => {
  const swiperRef = useRef(null);

  const data = [
    {
      img: "/assets/Images/Home/testimonial/img1.png",
      name: "Rahul Sharma",
      desgn: "RS Enterprises",
      descn:
        "Excellent print quality and fast delivery. The customized T-shirts & mugs looked amazing. Highly recommended for corporate branding.",
    },
    {
      img: "/assets/Images/Home/testimonial/img2.png",
      name: "Rahul Sharma",
      desgn: "RS Enterprises",
      descn:
        "Excellent print quality and fast delivery. The customized T-shirts & mugs looked amazing. Highly recommended for corporate branding.",
    },
    {
      img: "/assets/Images/Home/testimonial/img1.png",
      name: "Rahul Sharma",
      desgn: "RS Enterprises",
      descn:
        "Excellent print quality and fast delivery. The customized T-shirts & mugs looked amazing. Highly recommended for corporate branding.",
    },

    {
      img: "/assets/Images/Home/testimonial/img2.png",
      name: "Rahul Sharma",
      desgn: "RS Enterprises",
      descn:
        "Excellent print quality and fast delivery. The customized T-shirts & mugs looked amazing. Highly recommended for corporate branding.",
    },
    {
      img: "/assets/Images/Home/testimonial/img1.png",
      name: "Rahul Sharma",
      desgn: "RS Enterprises",
      descn:
        "Excellent print quality and fast delivery. The customized T-shirts & mugs looked amazing. Highly recommended for corporate branding.",
    },
    {
      img: "/assets/Images/Home/testimonial/img2.png",
      name: "Rahul Sharma",
      desgn: "RS Enterprises",
      descn:
        "Excellent print quality and fast delivery. The customized T-shirts & mugs looked amazing. Highly recommended for corporate branding.",
    },
  ];

  return (
    <section className="What_Customer_Say">
      <div className="custom_container">
        <div className="main_card">
          <div className="quote_img_div">
            <img
              src="/assets/Images/Home/testimonial/quote.png"
              className="quote_img"
            />
          </div>

          <div className="row">
            <div className="col-lg-4">
              <div className="left_div">
                <Homepage_common_heading
                  headingText={"What Our Customers Say"}
                  headingDescText={
                    "Trusted by businesses across industries. Real stories from happy & satisfied clients."
                  }
                />

                <div className="liveoffer_arrows">
                  <button onClick={() => swiperRef.current?.slidePrev()}>
                    <FaArrowLeft className="inner_icon"/>
                  </button>

                  <button onClick={() => swiperRef.current?.slideNext()}>
                    <FaArrowRight className="inner_icon"/>
                  </button>
                </div>
              </div>
            </div>

            <div className="col-lg-8">
              <div className="right_side">
                <div className="swiper_div">
                  <Swiper
                    onSwiper={(swiper) => (swiperRef.current = swiper)}
                    className="mySwiper"
                    spaceBetween={20}
                    slidesPerView={3.3}
                    speed={600}
                    grabCursor={true}
                    breakpoints={{
                      320: {
                        slidesPerView: 1,
                        spaceBetween: 10,
                      },
                      450: {
                        slidesPerView: 1.2,
                        spaceBetween: 10,
                      },
                      768: {
                        slidesPerView: 2,
                        spaceBetween: 15,
                      },
                      1024: {
                        slidesPerView: 2.5,
                        spaceBetween: 20,
                      },
                      1280: {
                        slidesPerView: 3,
                        spaceBetween: 20,
                      },
                       1500: {
                        slidesPerView: 3.3,
                        spaceBetween: 20,
                      },
                    }}
                  >
                    {data.map((item, index) => (
                      <SwiperSlide key={index}>
                        <div className="customer_card">
                          <div className="img_holder">
                            <img
                              src={process.env.PUBLIC_URL + item?.img}
                              className="inner_img"
                            />
                          </div>
                          <div className="text_holder">
                            <p className="name">{item?.name}</p>
                            <p className="desgn">{item?.desgn}</p>
                            <p className="description">{item?.descn}</p>
                          </div>
                        </div>
                      </SwiperSlide>
                    ))}
                  </Swiper>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default What_Customer_Say;
